import { Location } from "history";
import { matchPath } from "react-router";

export const isPathActive = (path: string, location: Location) => {
    return !!matchPath(location.pathname, { path });
};
